module.exports = __webpack_public_path__ + "static/media/shape-news-feed.dd73cebd.svg";